import { render } from "./logsDetail.vue?vue&type=template&id=72bdb257&scoped=true"
import script from "./logsDetail.vue?vue&type=script&lang=js"
export * from "./logsDetail.vue?vue&type=script&lang=js"

import "./logsDetail.vue?vue&type=style&index=0&id=72bdb257&lang=scss&scoped=true"
import "./logsDetail.vue?vue&type=style&index=1&id=72bdb257&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bdb257"]])

export default __exports__